// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AiSourceRowQueryVariables = Types.Exact<{
  afpId: Types.Scalars['ID']['input'];
}>;


export type AiSourceRowQuery = { __typename?: 'Query', aiFieldProposal: { __typename?: 'AiFieldProposal', id: string, parent: { __typename?: 'AiEntityProposal', id: string, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> } } };

export type AiSourceViewerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type AiSourceViewerQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, asset?: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string, attachmentUrl: string } | null | undefined } | null | undefined } };

export type AiSourceViewer_FieldProposalFragment = { __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } };

export const AiSourceViewer_FieldProposalFragmentDoc = gql`
    fragment AiSourceViewer_FieldProposal on AiFieldProposal {
  id
  fieldName
  fieldValue
  pageNumbers
  status {
    code
  }
}
    `;
export const AiSourceRowDocument = gql`
    query AiSourceRow($afpId: ID!) {
  aiFieldProposal(id: $afpId) {
    id
    parent {
      id
      fieldProposals {
        ...AiSourceViewer_FieldProposal
      }
    }
  }
}
    ${AiSourceViewer_FieldProposalFragmentDoc}`;

/**
 * __useAiSourceRowQuery__
 *
 * To run a query within a React component, call `useAiSourceRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSourceRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSourceRowQuery({
 *   variables: {
 *      afpId: // value for 'afpId'
 *   },
 * });
 */
export function useAiSourceRowQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiSourceRowQuery, AiSourceRowQueryVariables> & ({ variables: AiSourceRowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiSourceRowQuery, AiSourceRowQueryVariables>(AiSourceRowDocument, options);
      }
export function useAiSourceRowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiSourceRowQuery, AiSourceRowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiSourceRowQuery, AiSourceRowQueryVariables>(AiSourceRowDocument, options);
        }
// @ts-ignore
export function useAiSourceRowSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiSourceRowQuery, AiSourceRowQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceRowQuery, AiSourceRowQueryVariables>;
export function useAiSourceRowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceRowQuery, AiSourceRowQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceRowQuery | undefined, AiSourceRowQueryVariables>;
export function useAiSourceRowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceRowQuery, AiSourceRowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiSourceRowQuery, AiSourceRowQueryVariables>(AiSourceRowDocument, options);
        }
export type AiSourceRowQueryHookResult = ReturnType<typeof useAiSourceRowQuery>;
export type AiSourceRowLazyQueryHookResult = ReturnType<typeof useAiSourceRowLazyQuery>;
export type AiSourceRowSuspenseQueryHookResult = ReturnType<typeof useAiSourceRowSuspenseQuery>;
export type AiSourceRowQueryResult = ApolloReactCommon.QueryResult<AiSourceRowQuery, AiSourceRowQueryVariables>;
export const AiSourceViewerDocument = gql`
    query AiSourceViewer($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    aiProposal {
      id
      asset {
        id
        fileName
        downloadUrl
        attachmentUrl
      }
    }
  }
}
    `;

/**
 * __useAiSourceViewerQuery__
 *
 * To run a query within a React component, call `useAiSourceViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSourceViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSourceViewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAiSourceViewerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AiSourceViewerQuery, AiSourceViewerQueryVariables> & ({ variables: AiSourceViewerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiSourceViewerQuery, AiSourceViewerQueryVariables>(AiSourceViewerDocument, options);
      }
export function useAiSourceViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiSourceViewerQuery, AiSourceViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiSourceViewerQuery, AiSourceViewerQueryVariables>(AiSourceViewerDocument, options);
        }
// @ts-ignore
export function useAiSourceViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiSourceViewerQuery, AiSourceViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceViewerQuery, AiSourceViewerQueryVariables>;
export function useAiSourceViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceViewerQuery, AiSourceViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiSourceViewerQuery | undefined, AiSourceViewerQueryVariables>;
export function useAiSourceViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiSourceViewerQuery, AiSourceViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiSourceViewerQuery, AiSourceViewerQueryVariables>(AiSourceViewerDocument, options);
        }
export type AiSourceViewerQueryHookResult = ReturnType<typeof useAiSourceViewerQuery>;
export type AiSourceViewerLazyQueryHookResult = ReturnType<typeof useAiSourceViewerLazyQuery>;
export type AiSourceViewerSuspenseQueryHookResult = ReturnType<typeof useAiSourceViewerSuspenseQuery>;
export type AiSourceViewerQueryResult = ApolloReactCommon.QueryResult<AiSourceViewerQuery, AiSourceViewerQueryVariables>;